import { AdvisorEntity } from '../types/AdvisorEntity'
import ApiBase from './Api'

const ADVISOR_API_PATHS = {
    ADVISORS: '/advisors',
    ADVISOR_BY_ID: (advisorId: string) => `/advisors/${advisorId}`,
}

class AdvisorApi extends ApiBase {
    async findAll(): Promise<AdvisorEntity[]> {
        const response = await this._getRequest(ADVISOR_API_PATHS.ADVISORS)

        return response
    }
    async findByAdvisorId(advisorId: string | null): Promise<AdvisorEntity | null> {
        if (!advisorId) {
            return null
        }
        const response = await this._getRequest(ADVISOR_API_PATHS.ADVISOR_BY_ID(advisorId))

        return response
    }
    async findByIssueId(issueId: string | null): Promise<AdvisorEntity | null> {
        if (!issueId) {
            return null
        }
        const response = await this._getRequest(ADVISOR_API_PATHS.ADVISORS + `?issue=${issueId}`)

        return response
    }
}

export default AdvisorApi
